export default __webpack_public_path__ + "static/media/EN Co-Funded by the EU_POS.97b1ef8d.png";